import React from 'react';
import { Shapes, Square, Circle as CircleIcon, Pill, FileCode2 } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { FlyoutTab } from '../../editor-shell/components/flyout-tab';
import { useSvgUploader } from '../../svg-import';

export const ShapesButton: React.FC = () => {
  const { addRectangle, addCircle, addPill } = useEditorCanvas();
  const { openPicker } = useSvgUploader();

  return (
    <FlyoutTab
      panelId='shapes'
      label='Elementos'
      icon={<Shapes size={18} />}
      items={[
        { label: 'Rect', icon: <Square size={18} />, onClick: addRectangle },
        { label: 'Círculo', icon: <CircleIcon size={18} />, onClick: addCircle },
        { label: 'Pill', icon: <Pill size={18} />, onClick: addPill },
        { label: 'SVG', icon: <FileCode2 size={18} />, onClick: openPicker }
      ]}
    />
  );
};
